import React from 'react';
import BaseToolbar from 'components/Toolbar/BaseToolbar';
import { HOVER_HINT } from 'components/Toolbar/constants';
import BackgroundImage from 'components/Toolbar/Controls/BackgroundImage';
import BorderRadius from 'components/Toolbar/Controls/BorderRadius';
import FillColor from 'components/Toolbar/Controls/FillColor';
import FontSize from 'components/Toolbar/Controls/FontSize';
import Padding from 'components/Toolbar/Controls/Padding';
import Scrollable from 'components/Toolbar/Controls/Scrollable';
import ControlGroup from 'components/Toolbar/Shared/ControlGroup';
import { ProjectsConfig } from 'const';
import { intlGet } from 'utils/intlGet';
import { ToolbarProps } from './models';

const Toolbar: React.FunctionComponent<ToolbarProps> = (props) => {
  const {
    styles,
    stylesSetters,
    fontSize,
    layoutId,
    projectType,
    toggleFontSize,
  } = props;
  const { allowBackgroundOpacity, allowBackgroundImage, allowScrollableLayout } = ProjectsConfig[projectType];

  return (
    <BaseToolbar title={intlGet('EditorToolbar.Asset', 'Layout')} layoutId={layoutId} dataTestId='referenceCitationElement-baseToolbar'>
      <ControlGroup dataTestId='controlGroup0'>
        <FontSize
          fontSize={fontSize}
          toggleFontSize={toggleFontSize}
          dataTestId='referenceCitationElement-fontSizeControl'
        />
      </ControlGroup>
      <ControlGroup dataTestId='controlGroup1'>
        <Padding
          padding={styles.padding}
          togglePadding={stylesSetters.padding}
          dataTestId='referenceCitationElement-padding'
        />
        <FillColor
          activeColor={styles.backgroundColor}
          toggleColor={stylesSetters.backgroundColor}
          opacity={styles.backgroundColorOpacity}
          toggleOpacity={allowBackgroundOpacity ? stylesSetters.backgroundColorOpacity : null}
          gradient={styles.backgroundGradient}
          toggleGradient={stylesSetters.backgroundGradient}
          dataTestId='referenceCitationElement-fillColor'
        />
        {allowBackgroundImage && <BackgroundImage
          backgroundImage={styles.backgroundImage}
          toggleBackgroundImage={stylesSetters.backgroundImage}
          dataTestId='referenceCitationElement-backgroundImage'
        />}
        <BorderRadius
          borderRadius={styles.borderRadius}
          title={HOVER_HINT.LAYOUT}
          dropdownWarningMessage={intlGet('EditorToolbar.Tooltip', 'WarningMessage')}
          toggleBorderRadius={stylesSetters.borderRadius}
          dataTestId='referenceCitationElement-borderRadius'
        />
      </ControlGroup>
      {allowScrollableLayout &&
        <ControlGroup dataTestId='controlGroup2'>
          <Scrollable
            scrollable={styles.scrollable}
            toggleScrollable={(): void => stylesSetters.scrollable(!styles.scrollable)}
            dataTestId='referenceCitationElement-scrollable'
          />
        </ControlGroup>
      }
    </BaseToolbar>
  );
};

export default Toolbar;
